export const SHOW_CONFIRMATION_MODAL = 'SHOW_CONFIRMATION_MODAL';
export const HIDE_CONFIRMATION_MODAL = 'HIDE_CONFIRMATION_MODAL';
export const SET_UPGRADE_MODAL = 'SET_UPGRADE_MODAL';
export const ADD_FLASH_MESSAGE = 'ADD_FLASH_MESSAGE';
export const REMOVE_FLASH_MESSAGE = 'REMOVE_FLASH_MESSAGE';
export const SET_404 = 'SET_404';
export const SET_LOGGED_IN = 'SET_LOGGED_IN';
export const SET_SETTINGS = 'SET_SETTINGS';
export const SET_FILE_SIZES = 'SET_FILE_SIZES';
export const SET_USER_FIELDS = 'SET_USER_FIELDS';
export const SET_DOWNLOAD_URL = 'SET_DOWNLOAD_URL';
export const SET_DROPPED_FILES = 'SET_DROPPED_FILES';
export const CLEAR_DROPPED_FILES = 'CLEAR_DROPPED_FILES';
export const SET_PROGRESS = 'SET_PROGRESS';
export const SET_ONLINE_USERS = 'SET_ONLINE_USERS';
export const BLOCK_NAVIGATION = 'BLOCK_NAVIGATION';
export const SET_BACKEND_ACTION = 'SET_BACKEND_ACTION';
export const SET_LANGUAGE_MESSAGES = 'SET_LANGUAGE_MESSAGES';
export const SET_FEATURES = 'SET_FEATURES';
export const SET_COUPONS = 'SET_COUPONS';
export const SET_SIDEBAR_OPEN = 'SET_SIDEBAR_OPEN';
export const SET_SECOND_SIDEBAR_OPEN = 'SET_SECOND_SIDEBAR_OPEN';
export const SET_SIDEBAR_ACTIVE_TAB = 'SET_SIDEBAR_ACTIVE_TAB';
export const SET_APP_VERSION = 'SET_APP_VERSION';
export const SET_APP_UPDATE_AVAILABLE = 'SET_APP_UPDATE_AVAILABLE';
export const SET_G2_LOADING = 'SET_G2_LOADING';

export const showConfirmationModal = params => ({
  type: SHOW_CONFIRMATION_MODAL,
  params,
});

export const hideConfirmationModal = () => ({
  type: HIDE_CONFIRMATION_MODAL,
});

export const setUpgradeModal = (modal) => ({
  type: SET_UPGRADE_MODAL,
  modal,
});

export const addFlashMessage = message => ({
  type: ADD_FLASH_MESSAGE,
  message,
});

export const removeFlashMessage = messageId => ({
  type: REMOVE_FLASH_MESSAGE,
  messageId,
});

export const set404 = status => ({
  type: SET_404,
  status,
});

export const setLoggedIn = loggedIn => ({
  type: SET_LOGGED_IN,
  loggedIn,
});

export const setSettings = settings => ({
  type: SET_SETTINGS,
  settings,
});

export const setFileSizes = fileSizes => ({
  type: SET_FILE_SIZES,
  fileSizes,
});

export const setUserFields = userFields => ({
  type: SET_USER_FIELDS,
  userFields,
});

export const setDownloadUrl = downloadUrl => ({
  type: SET_DOWNLOAD_URL,
  downloadUrl,
});

export const setDroppedFiles = files => ({
  type: SET_DROPPED_FILES,
  files,
});

export const clearDroppedFiles = () => ({
  type: CLEAR_DROPPED_FILES,
});

export const setProgress = (total, done) => ({
  type: SET_PROGRESS,
  total,
  done,
});

export const resetProgress = () => ({
  type: SET_PROGRESS,
  done: 0,
  total: 0,
});

export const setOnlineUsers = (users) => ({
  type: SET_ONLINE_USERS,
  users,
});

export const blockNavigation = (block) => ({
  type: BLOCK_NAVIGATION,
  block,
});

export const setBackendAction = (action) => ({
  type: SET_BACKEND_ACTION,
  action,
});

export const setLanguageMessages = messages => ({
  type: SET_LANGUAGE_MESSAGES,
  messages,
});

export const setFeatures = features => ({
  type: SET_FEATURES,
  features,
});

export const setCoupons = coupons => ({
  type: SET_COUPONS,
  coupons,
});

export const setSidebarOpen = sidebarOpen => ({
  type: SET_SIDEBAR_OPEN,
  sidebarOpen,
});

export const setSecondSidebarOpen = secondSidebarOpen => ({
  type: SET_SECOND_SIDEBAR_OPEN,
  secondSidebarOpen,
});

export const setSidebarActiveTab = sidebarActiveTab => ({
  type: SET_SIDEBAR_ACTIVE_TAB,
  sidebarActiveTab,
});

export const setAppVersion = version => ({
  type: SET_APP_VERSION,
  version,
});

export const setAppUpdateAvailable = (updateAvailable) => ({
  type: SET_APP_UPDATE_AVAILABLE,
  updateAvailable,
});

export const setG2Loading = (loading) => ({
  type: SET_G2_LOADING,
  loading,
});
